import { IntegrationRequirementsWebComponent } from './component/IntegrationRequirementsWebComponent';
import { WEB_COMPONENT_INTEGRATION_REQUIREMENTS } from '../../webcomponents.constants';

export { IntegrationRequirementsWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRATION_REQUIREMENTS, IntegrationRequirementsWebComponent);
